import BaseApi from './baseApi';
import IListStatusTransformation from '../models/IListStatusTransformation';
import IAuthentication from '../models/IAuthentication';
export default class ListStatusTransformationApi extends BaseApi {
    idUser : string = "";
    idCompany : string = "";
    constructor() {
        super("dataaccess", "Settings");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
        this.idCompany = userFromStorage.idCompany;
    }

    async GetListStatusTransformation() : Promise<IListStatusTransformation[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var listStatusTransformation: IListStatusTransformation[] = [];
            listStatusTransformation = response.data as IListStatusTransformation[];
            return listStatusTransformation;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveListStatusTransformation(listStatusTransformation: IListStatusTransformation) : Promise<string> {
        const json = this.getJsonSave(listStatusTransformation);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateListStatusTransformation(listStatusTransformation: IListStatusTransformation) : Promise<boolean> {
        const json = this.getJsonUpdate(listStatusTransformation);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteListStatusTransformation(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async inUseSetting(id: string) : Promise<boolean> {
        const json = this.getInUseJson(id);
        const response = await this.api.post('ExecWithResults', json);
        if (!response) return false;
        if (response.isSuccess) {
            const data = response.data as any[];
            return Number(data && data[0] && data[0].isInUse) === 1;
        } else {
            this.modelState = response.errorState;
            return false;
        }
    }

    private getInUseJson(id: string) : any {
        const json = {
            "spname": "dbo.IS_STATUS_TRANSFORMATION_IN_USE",
            "parameters": [{
                "Item1": "StatusTransformationId ",
                "Item2": id
            }, {
                "Item1": "companyId ",
                "Item2": this.idCompany
            }]
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "ListStatusTransformation",
                "Item2": "id"
            }, {
                "Item1": "ListStatusTransformation",
                "Item2": "name"
            }, {
                "Item1": "ListStatusTransformation",
                "Item2": "idCompany"
            }],
            "tables": [{
                "Item1": "ListStatusTransformation"
            }],
            "conditions": [{
                "Item1": "ListStatusTransformation",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "ListStatusTransformation",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": this.idCompany
            }],
            "orderBy": [{
                "Item1": "ListStatusTransformation.name"
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "ListStatusTransformation",
            "conditions": [{
                "Item1": "ListStatusTransformation",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(listStatusTransformation: IListStatusTransformation) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listStatusTransformation.name
            }, {
                "Item1": "idCompany",
                "Item2": listStatusTransformation.idCompany
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "ListStatusTransformation"
        };
        return json;
    }

    private getJsonUpdate(listStatusTransformation: IListStatusTransformation) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listStatusTransformation.name
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "ListStatusTransformation",
            "keyvalue": listStatusTransformation.id
        };
        return json;
    }
}
